/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `Zurück zur Homepage`
};

const en_action__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `Back to homepage`
};

const es_action__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `Volver a la página de inicio`
};

const fr_action__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `Retour à la page d'accueil`
};

const it_action__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `Torna alla home page`
};

const nl_action__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `Terug naar de startpagina`
};

const pt_action__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `Voltar à página inicial`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__back_home = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__back_home(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__back_home", locale)
	if (locale === "de") return de_action__back_home(inputs)
	if (locale === "en") return en_action__back_home(inputs)
	if (locale === "es") return es_action__back_home(inputs)
	if (locale === "fr") return fr_action__back_home(inputs)
	if (locale === "it") return it_action__back_home(inputs)
	if (locale === "nl") return nl_action__back_home(inputs)
	return pt_action__back_home(inputs)
};